export type ParseUrlEmailProps = {
  email: string;
};

export const parseUrlEmail = ({ email }: ParseUrlEmailProps) =>
  decodeURIComponent(email).replace(/ /g, "+");
